module.exports = __webpack_public_path__ + "img/bottom2.a770d77f.png";